import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    contentCol: PropTypes.object,
};

export default class ContentCol extends React.Component {
    constructor(props) {
        super(props)
    }

    render() {
        const {contentCol} = this.props;
        const {index, title, panelIcon, panelLabel, circleStyle, desc, isImg, imgSrc} = contentCol;


        return(
            <div className='contentCol--holder' >
                <div className={`content-circle ${circleStyle}`}>{index}</div>
                <h3 className='content-title'>{title}</h3>
                <div className='c-panel--holder'>
                    {isImg === true?
                        <img className='c-img-icon' src={imgSrc}/>:
                        <h2 className='c-panel--icon'><i className={panelIcon}></i></h2>
                    }
                    <h2 className='c-panel--label'>{panelLabel}</h2>
                </div>
                <ul className='desc-list'>
                    {desc.map((item, index) => (
                        <li key={index}> {item} </li>
                    ))}
                </ul>
            </div>
        );
    }
};

ContentCol.propTypes = propTypes;


// WEBPACK FOOTER //
// ./src/components/SignupContentRow/ContentCol.js